// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';

export const v1HoursQuerySchema = z.object({
  since: z.optional(z.string().date()),
  upto: z.optional(z.string().date()),
  day: z.optional(z.string().date()),
  hour_ids: z.optional(z.coerce.string()),
  sort: z.optional(z.enum(["day", "created_at", "updated_at"])),
  order: z.optional(z.enum(["asc", "desc"])),
  per_page: z.optional(z.number().int().min(1).max(5000)),
  page: z.optional(z.number().int().min(1)),
  project_id: z.optional(z.number().int()),
  user_id: z.optional(z.number().int()),
  autosheet_proposal_id: z.optional(z.coerce.string().describe("Filter to hours linked to a specific AutoSheet proposal")),
});
